export default {
  name: "Clients",
  path: "/accounts",
  component: () => import("@/views/Clients")
};
